import { render } from "./accountSpent.vue?vue&type=template&id=71f2a2b2&scoped=true"
import script from "./accountSpent.vue?vue&type=script&lang=js"
export * from "./accountSpent.vue?vue&type=script&lang=js"

import "./accountSpent.vue?vue&type=style&index=0&id=71f2a2b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f2a2b2"]])

export default __exports__